// Actions
export const LOAD_TASTINGS = 'LOAD_TASTINGS'
export const NEXT_SECTION = 'NEXT_SECTION'
export const NEXT_TASTING_STEP = 'NEXT_TASTING_STEP'
export const PREV_TASTING_STEP = 'PREV_TASTING_STEP'
export const SUBMIT_TASTING_ANSWER = 'SUBMIT_TASTING_ANSWER'
export const RESTORE_PENDING_TASTING_FUNNEL = 'RESTORE_PENDING_TASTING_FUNNEL'

// Commits
export const SET_TASTINGS = 'SET_TASTINGS'
export const SET_SECTIONS = 'SET_SECTIONS'
export const SET_TASTING_QUESTIONS = 'SET_TASTING_QUESTIONS'
export const SET_TASTING_TRANSITIONS = 'SET_TASTING_TRANSITIONS'
export const SET_TASTING_ANSWER = 'SET_TASTING_ANSWER'
export const SET_TASTING_FIREBASE_ID = 'SET_TASTING_FIREBASE_ID'
export const RESET_TASTING_FIREBASE_ID = 'RESET_TASTING_FIREBASE_ID'
